'use client';

import { useCallback } from 'react';

import { ProjectTabs as ProjectTabsEnum } from '@/app/pages/ProjectDetail/types';

import { ProjectSettingsModeGroupEnum } from '@/app/api';
import Tabs, { Tab } from '@/app/components/Tabs/Tabs';
import { DonateButton } from '@/app/pages/ProjectDetail/components/DonateButton';
import { useIsProjectActive } from '@/app/providers/ProjectProvider';

interface ProjectTabsProps {
  tabs: Tab<ProjectTabsEnum>[];
  activeTabId: ProjectTabsEnum;
  onTabChange: (nextTab: ProjectTabsEnum) => void;
  donationLink: string;
  isElementFixed: boolean;
  onToggleElementFixed: (nextIsFixed: boolean) => void;
  projectModeGroup: ProjectSettingsModeGroupEnum;
  onCommercialDonationClick?: () => void;
}

const ProjectTabs = ({
  tabs,
  activeTabId,
  donationLink,
  isElementFixed,
  onTabChange,
  onToggleElementFixed,
  projectModeGroup,
  onCommercialDonationClick,
}: ProjectTabsProps) => {
  const isProjectActive = useIsProjectActive();
  const isAdditionalContentVisible = isElementFixed && isProjectActive;

  const handleSelectTab = useCallback(
    (tabId: ProjectTabsEnum) => {
      onTabChange(tabId);
    },
    [onTabChange],
  );

  return (
    <Tabs<ProjectTabsEnum>
      tabs={tabs}
      onSelectTab={handleSelectTab}
      activeTabId={activeTabId}
      onToggleElementFixed={onToggleElementFixed}
      isStickyOnDesktop
      className="mb-[32px] border-b border-b-neutral-light"
      additionalContent={
        isAdditionalContentVisible && (
          <DonateButton
            onCommercialDonationClick={onCommercialDonationClick}
            projectModeGroup={projectModeGroup}
            donationLink={donationLink}
          />
        )
      }
    />
  );
};

export default ProjectTabs;
